import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Bank Cell Renderer
 * Muestra nombre del banco y cuenta
 */
@Component({
  selector: 'app-bank-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ bankName }}</span>
      <span class="text-sm text-gray-500 dark:text-gray-400">{{ accountName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class BankCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get bankName(): string {
    const dataAny = this.params?.data as any;
    return dataAny?.bank?.name ?? '-';
  }

  get accountName(): string {
    const dataAny = this.params?.data as any;
    return dataAny?.account?.name ?? '-';
  }
}
